import React, { useState, useEffect } from 'react';

interface StatData {
  text: string;
  emoji: string;
  highlight: string;
}

interface RotatingStatsProps {
  stats: StatData[];
  interval?: number;
  className?: string;
}

const RotatingStats: React.FC<RotatingStatsProps> = ({ 
  stats, 
  interval = 3000, 
  className = '' 
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isChanging, setIsChanging] = useState(false);

  useEffect(() => {
    const rotateStat = () => {
      setIsChanging(true);
      
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % stats.length);
        
        setTimeout(() => {
          setIsChanging(false);
        }, 300);
      }, 300);
    };

    // Start immediately with the first stat
    if (currentIndex === 0) {
      rotateStat();
    }

    const intervalId = setInterval(rotateStat, interval);
    return () => clearInterval(intervalId);
  }, [stats.length, interval, currentIndex]);

  const formatStat = (stat: StatData) => {
    const { text, emoji, highlight } = stat;
    
    // Replace highlight text with span
    const formattedText = text.replace(
      highlight,
      `<span class="stat-highlight">${highlight}</span>`
    );
    
    return {
      emoji,
      formattedText
    };
  };

  const currentStat = stats[currentIndex];
  const { emoji, formattedText } = formatStat(currentStat);

  return (
    <span className={`rotating-stats ${isChanging ? 'changing' : ''} ${className}`}>
      <span className="stat-emoji">{emoji}</span>
      {' '}
      <span 
        dangerouslySetInnerHTML={{ __html: formattedText }}
      />
    </span>
  );
};

export default RotatingStats; 